import type { SVGProps } from 'react';

export function TrezorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.958 6.642C16.958 4.105 14.722 2 11.999 2S7.04 4.106 7.04 6.642v.983a.5.5 0 0 1-.5.5H5.5a.5.5 0 0 0-.5.5v9.85a.5.5 0 0 0 .292.455l6.499 2.975a.5.5 0 0 0 .416 0l6.501-2.977a.5.5 0 0 0 .292-.455V8.671a.5.5 0 0 0-.5-.5h-1.041a.5.5 0 0 1-.5-.5zm-7.39 0c0-1.197 1.07-2.154 2.431-2.154s2.431.957 2.431 2.154v.983a.5.5 0 0 1-.5.5h-3.862a.5.5 0 0 1-.5-.5zm6.612 10.11a.5.5 0 0 1-.292.455l-3.68 1.685a.5.5 0 0 1-.417 0l-3.68-1.685a.5.5 0 0 1-.293-.455v-5.591a.5.5 0 0 1 .5-.5h7.362a.5.5 0 0 1 .5.5z" />
    </svg>
  );
}
